module.exports = __webpack_public_path__ + "static/media/016.281751fe.jpg";